import React, { Component, Fragment } from "react"
import ContentEditable from "react-sane-contenteditable"
import WithApp from "data/wrappers/WithApp"
import { Link } from "react-router"
import RenderTree from "../../RenderTree"
import { TreeInstance } from "features/editor/tree/tree"
import { cloneDeep } from "lodash"
import { Container } from "ui"

/**
 * @augments {Component<BlockTypeProps<{text: string}>, any>}
 */
export default class NavMenuBlockType extends Component {
    state = { edits: { edit: null, callback: null } }

    render() {
        const Wrapper = this.props.Wrapper

        // We store the two templates for the different links (active, inactive) as child blocks
        const inactiveLink = this.props.childBlocks.filter(
            block => block.local_id === "menu_inactive"
        )[0]
        const activeLink = this.props.childBlocks.filter(
            block => block.local_id === "menu_active"
        )[0]
        const renderLink = (label, url, active) => {
            let link = cloneDeep(active ? activeLink : inactiveLink)
            link.childBlocks[0].config.attributes.text = label
            let tree = new TreeInstance([link])

            return (
                <Link key={label} to={url}>
                    <RenderTree instance={tree} />
                </Link>
            )
        }

        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle, updateAttributes, selected }) => (
                    <Container>
                        <WithApp appId={this.props.context.editor.page.app_id}>
                            {({ app }) => {
                                const menu = (app.options && app.options.menu) || []
                                const isActive = pageId =>
                                    pageId === this.props.context.editor.page._sid
                                return menu.map(item =>
                                    renderLink(item.name, app.url + item.url, isActive(item.pageId))
                                )
                            }}
                        </WithApp>
                    </Container>
                )}
            </Wrapper>
        )
    }
}

NavMenuBlockType.attributes = []

NavMenuBlockType.defaultChildBlocks = [
    {
        type: "container",
        config: {
            attributes: { direction: "row", userAdded: true },
            style: { default: { "font-weight": "bold" } },
            broadcast: [],
        },
        childBlocks: [
            {
                id: "menu_inactive_text",
                type: "string",
                config: {
                    style: { default: { "font-weight": "normal" } },
                    broadcast: [],
                    attributes: { text: "Inactive" },
                },
                childBlocks: [],
            },
        ],
        local_id: "menu_inactive",
        default_id: "menu_inactive",
        id: "menu_inactive",
    },
    {
        type: "container",
        config: {
            attributes: { direction: "column", userAdded: true },
            style: { default: { "font-weight": "bold" } },
            broadcast: [],
        },
        childBlocks: [
            {
                id: "menu_active_text",
                type: "string",
                config: {
                    style: { default: { "font-weight": "bold" } },
                    broadcast: [],
                    attributes: { text: "Inactive" },
                },
                childBlocks: [],
            },
        ],
        local_id: "menu_active",
        default_id: "menu_active",
        id: "menu_active",
    },
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/layout/NavMenuBlock.js